import { ActionItemRow } from "components/HomeActionItems/ActionItemRow";
import { CartActionItem } from "components/HomeActionItems/CartActionItem";
import { FilingList } from "components/HomeActionItems/FilingList";
import { PendingInvoicesRow } from "components/HomeActionItems/PendingInvoicesRow";
import { UnreadChatRow } from "components/HomeActionItems/UnreadChatRow";
import { useAuth } from "hooks/useAuth";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { TodoListLoader } from "pages/TodoList/TodoListLoader";
import React, { useMemo } from "react";
import {
  TaxActionItemType,
  useGetActionItemsQuery,
} from "store/apis/actionItems";
import EmptyActionItem from "static/images/EmptyActionItem.svg";
import { Form1099Actions } from "components/HomeActionItems/Form1099Actions";
import { StateComplianceActionItem } from "components/HomeActionItems/StateComplianceActionItem";

export const TaxTodos = ({
  selectedStatusTab,
  showEmptyState,
}: {
  selectedStatusTab: "REQUESTED" | "DEPRECATED" | "SUBMITTED";
  showEmptyState?: boolean;
}) => {
  const userProfile = useAuth();
  const { uuid: groupId } = useCurrentGroupContext();
  const { data = { tax_action_items: [] }, isLoading: isTaxLoading } =
    useGetActionItemsQuery(
      {
        groupId: groupId,
        type: "TAX",
        card_status: selectedStatusTab || null,
      },
      {
        skip: !groupId || !selectedStatusTab,
      }
    );

  const taxActionItems = useMemo(() => {
    if (!("tax_action_items" in data)) return [];
    const taxItems = (data as { tax_action_items: TaxActionItemType[] })
      .tax_action_items;
    return [...taxItems].sort((a, b) => {
      if (a.order == null && b.order == null) return 0;
      if (a.order == null) return 1;
      if (b.order == null) return -1;
      return a.order - b.order;
    });
  }, [data]);

  if (isTaxLoading) {
    return <TodoListLoader />;
  }

  if (showEmptyState && taxActionItems.length === 0) {
    return (
      <div className="t-flex t-items-center t-justify-center t-h-full">
        <img src={EmptyActionItem} alt="noActions" />
      </div>
    );
  }

  return (
    <div>
      {taxActionItems.map((item, i) => {
        if (item.custom_type === "FILING_IN_ADD_DETAILS_CUSTOM_TYPE") {
          return <FilingList key={i} item={item} />;
        }
        if (item.custom_type === "CART") {
          return <CartActionItem key={i} item={item} />;
        }
        if (item.custom_type === "INVOICES_DUE") {
          return <PendingInvoicesRow key={i} item={item} />;
        }
        if (item.custom_type === "W_FORMS_PENDING") {
          return <Form1099Actions item={item} key={i} groupId={groupId} />;
        }
        if (
          item.custom_type === "STATE_REGISTRATIONS_DUE" ||
          item.custom_type === "STATE_REGISTRATION_MISSING_INFO" ||
          item.custom_type === "RA_EXPIRING"
        ) {
          return <StateComplianceActionItem item={item} key={i} />;
        }
        return <ActionItemRow item={item} key={i} />;
      })}
    </div>
  );
};
